module.exports = __webpack_public_path__ + "static/media/mk.8ab4fec3.svg";